<template>
  <div class="login-bg">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 text-center">
          <h2
            v-bind:style="{
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
            }"
          >
            {{ tagline }}
          </h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="card rounded-lg p-4">
          <b-row class="mt-2 ml-2">
            <b-col md="12">
              <div class="pl-4 pr-5">
                <h4 class="d-flex align-items-center">
                  <router-link button to="/">
                    <b-icon icon="arrow-left-short"></b-icon>
                  </router-link>
                  <span class="ml-2"
                    >{{ $t("loginWith.welcomeTo") }} {{ appName }}</span
                  >
                </h4>
                <p>
                  {{ $t("logintoDiscover") }} <br />
                  {{ $t("newTo") }} {{ appName }}?
                  <router-link
                    to="/register"
                    style="text-decoration: underline"
                  >
                    {{ $t("createAccount") }}
                  </router-link>
                </p>
              </div>
            </b-col>
          </b-row>
          <div class="d-flex flex-column align-items-center gap-3 mt-3 mb-4">
            <b-button
              variant="outline-secondary"
              class="signin-btn"
              @click="$router.push('/login?type=otp')"
            >
              <b-icon icon="telephone-fill" class="me-2"></b-icon>
              {{ $t("loginWith.signWithPhone") }}
            </b-button>

            <b-button
              variant="outline-secondary"
              class="signin-btn"
              @click="$router.push('/login?type=email')"
            >
              <b-icon icon="envelope-fill" class="me-2"></b-icon>
              {{ $t("loginWith.signWithEmail") }}
            </b-button>

            <b-button
              variant="outline-secondary"
              class="signin-btn google-btn"
              @click="googleLogin"
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                alt="Google"
                class="icon-img me-2"
              />
              {{ $t("loginWith.signWithGoogle") }}
            </b-button>

            <b-button
              variant="outline-secondary"
              class="signin-btn facebook-btn"
              @click="facebookLogin"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                alt="Facebook"
                class="icon-img me-2"
              />
              {{ $t("loginWith.signWithFacebook") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import GoogleLogin from "vue-google-login";
import { socialLoginSignup } from "../auth.services";
import { mapState } from "vuex";
import {
  GoogleAuthProvider,
  // FacebookAuthProvider,
  getAuth,
  signInWithPopup,
} from "firebase/auth";
import config from "/public/config.json";
export default {
  name: "login",
  components: {
    //  GoogleLogin,
  },
  computed: {
    ...mapState({
      cartData: (state) => state.checkout.cartData,
    }),
  },
  data() {
    return {
      phone: "",
      password: "",
      otpMsg: { value: "", key: "" },
      otpKey: false,
      otpInput1: "",
      otpInput2: "",
      otpInput3: "",
      otpInput4: "",
      isLoading: false,
      appName: config.appName,
      tagline: config.tagline,
      passwordRules: [(v) => !!v || "Password is required"],
      showPassword: false,
      countDownObj: {
        countDownVar: 0,
        msg: "",
      },
    };
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    timerFunc() {
      this.countDownObj.countDownVar = 60;
      this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
      clearInterval(countDownIntervalFunc);
      const countDownIntervalFunc = setInterval(() => {
        this.countDownObj.countDownVar--;
        if (this.countDownObj.countDownVar < 10) {
          this.countDownObj.msg = `00 : 0${this.countDownObj.countDownVar}`;
        } else if (this.countDownObj.countDownVar > 10) {
          this.countDownObj.msg = `00 : ${this.countDownObj.countDownVar}`;
        }
        if (this.countDownObj.countDownVar < 0) {
          clearInterval(countDownIntervalFunc);
        }
      }, 1000);
    },
    googleLogin() {
      const x = new GoogleAuthProvider();
      signInWithPopup(getAuth(), x)
        .then(async (res) => {
          try {
            let result = await socialLoginSignup({
              data: {
                accessToken: res._tokenResponse.oauthIdToken,
              },
              type: "GOOGLE",
            });
            if (result.data.response.registration) {
              result = await socialLoginSignup({
                data: {
                  accessToken: res._tokenResponse.oauthIdToken,
                  category: "CUSTOMER",
                },
                type: "GOOGLE",
              });
            }
            result.data.response.user.name.first = res._tokenResponse.firstName;
            result.data.response.user.name.last = res._tokenResponse.lastName;
            // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
            const userdata = {
              ...result.data.response.user,
              loginType: "social",
            };
            if (result) {
              const token = await result.data.response.token;
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(userdata)
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch("auth/setUserData", userdata);
              this.$store.commit(
                "address/setDeliveryAddress",
                userdata.addresses
              );
              setTimeout(() => {
                this.$router.push("/");
              }, 1500);
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log("google err", err);
        });
    },
    facebookLogin() {
      this.$swal({
        title: "",
        text: "Facebook login is currently unavailable. Please try again later or try with other methods.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
      // const x = new FacebookAuthProvider();
      // signInWithPopup(getAuth(), x)
      //   .then(async (res) => {
      //     const credential = FacebookAuthProvider.credentialFromResult(res);
      //     const accessToken = credential.accessToken;
      //     try {
      //       let result = await socialLoginSignup({
      //         data: {
      //           accessToken: accessToken,
      //         },
      //         type: "FACEBOOK",
      //       });

      //       if (result.data.response.registration) {
      //         result = await socialLoginSignup({
      //           data: {
      //             accessToken: accessToken,
      //             category: "CUSTOMER",
      //           },
      //           type: "FACEBOOK",
      //         });
      //       }
      //       result.data.response.user.name.first = res._tokenResponse.firstName;
      //       result.data.response.user.name.last = res._tokenResponse.lastName;
      //       // result.data.response.user.extendedAttributes.profilePhoto=res._tokenResponse.photoUrl;
      //       const userdata = {
      //         ...result.data.response.user,
      //         loginType: "social",
      //       };
      //       if (result) {
      //         const token = await result.data.response.token;
      //         localStorage.setItem(`${process.env.VUE_APP_TENANT}:access_token`, token);
      //         localStorage.setItem(
      //           `${process.env.VUE_APP_TENANT}:userInfo`,
      //           JSON.stringify(userdata),
      //         );
      //         this.$store.dispatch("auth/loginToken", token);
      //         this.$store.dispatch("auth/setUserData", userdata);
      //         this.$store.commit(
      //           "address/setDeliveryAddress",
      //           userdata.addresses,
      //         );
      //         setTimeout(() => {
      //           this.$router.push("/");
      //         }, 1500);
      //       }
      //     } catch (error) {
      //       console.log(error);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log("google err", err);
      //   });
    },
    async loginOtp() {
      this.isLoading = true;
      const payload = {};
      payload.mobile = this.phone;
      payload.otp =
        this.otpInput1 + this.otpInput2 + this.otpInput3 + this.otpInput4;
      await this.$store
        .dispatch("auth/callLogin", payload)
        .then(async (result) => {
          const token = await result.data.response.token;
          if (token) {
            localStorage.setItem(
              `${process.env.VUE_APP_TENANT}:access_token`,
              token
            );
            localStorage.setItem(
              `${process.env.VUE_APP_TENANT}:userInfo`,
              JSON.stringify(result.data.response.user)
            );
            this.$store.dispatch("auth/loginToken", token);
            this.$store.dispatch("auth/setUserData", result.data.response.user);
            this.$store.commit(
              "address/setDeliveryAddress",
              result.data.response.user.addresses
            );
            setTimeout(() => {
              this.$router.push("/");
              this.isLoading = false;
            }, 1500);
          }
        })
        .catch((err) => {
          console.log(err);
          this.otpMsg = { value: "Invalid Verification", key: "red" };
          this.otpInput1 =
            this.otpInput2 =
            this.otpInput3 =
            this.otpInput4 =
              "";
          this.isLoading = false;
        });
    },
    async onSuccess(googleUser) {
      const authDetails = googleUser.getAuthResponse();
      // const basicProfileDetail = googleUser.getBasicProfile();
      try {
        const result = await socialLoginSignup({
          data: {
            accessToken: authDetails.id_token,
          },
          type: "GOOGLE",
        });
        // result.data.response.user.name.first= res._tokenResponse;
        const userdata = {
          ...result.data.response.user,
          loginType: "social",
        };
        if (result) {
          const token = await result.data.response.token;
          //const user = await result.data.response.user;
          localStorage.setItem(
            `${process.env.VUE_APP_TENANT}:access_token`,
            token
          );
          localStorage.setItem(
            `${process.env.VUE_APP_TENANT}:userInfo`,
            JSON.stringify(userdata)
          );
          this.$store.dispatch("auth/loginToken", token);
          this.$store.dispatch("auth/setUserData", userdata);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onFailure(error) {
      console.log(error);
    },
    async loginWithPsw() {
      try {
        if (!this.phone || !this.password) {
          this.$swal({
            type: "error",
            title: this.$t("swal.missingFields"),
            text: this.$t("swal.fillRequiredFields"),
          });
          return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[6-9]\d{9}$/;
        if (emailRegex.test(this.phone)) {
          this.email = this.phone;
          this.mobile = Math.round(Date.now() / 1000).toString();
        } else if (phoneRegex.test(this.phone)) {
          this.mobile = this.phone;
          this.email =
            "sha256" +
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15) +
            "@indianmangoes.com";
        } else {
          this.$swal({
            type: "error",
            title: this.$t("swal.invalidInput"),
            text: this.$t("swal.enterValidEmailOrPhone"),
          });
          return;
        }
        const isEmail = this.phone.includes("@");

        const payload = {
          ...(isEmail ? { email: this.phone } : { phone: this.phone }),
          password: this.password,
        };
        await this.$store
          .dispatch("auth/loginWithPassword", payload)
          .then(async (result) => {
            const token = await result.data.response.token;
            if (token) {
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:access_token`,
                token
              );
              localStorage.setItem(
                `${process.env.VUE_APP_TENANT}:userInfo`,
                JSON.stringify(result.data.response.user)
              );
              this.$store.dispatch("auth/loginToken", token);
              this.$store.dispatch(
                "auth/setUserData",
                result.data.response.user
              );
              this.$store.commit(
                "address/setDeliveryAddress",
                result.data.response.user.addresses
              );
              setTimeout(() => {
                this.$router.push("/");
                this.isLoading = false;
              }, 1500);
            }
          });
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "An unexpected error occurred";
        this.$swal({
          type: "error",
          title: errorMessage,
          confirmButtonColor: "#FF5733",
        });
        this.isLoading = false;
      }
    },
    async login() {
      this.isLoading = true;
      try {
        const payload = {};
        payload.mobile = this.phone;
        const result = await this.$store.dispatch("auth/callLogin", payload);
        if (result.response) {
          let msg = result.response.data.message;
          this.$swal({
            text: msg,
            type: "error",
          });
        }
        if (result.data.status == 1) {
          this.otpKey = true;
          this.otpMsg = { value: result.data.message, key: "green" };
          this.timerFunc();
        } else {
          this.otpMsg = { value: "can not send otp", key: "red" };
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.login-heading {
  margin-left: 20px;
}
.logo p {
  font-size: 1rem;
}
.toggle-password {
  position: absolute;
  top: 70%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 1.25rem;
  z-index: 10;
  line-height: 1;
}
.password-field >>> .v-input__append-inner {
  cursor: pointer;
}
::v-deep .v-messages__message {
  color: red;
}
.password-field >>> .v-icon {
  background: none !important;
  padding: 0 !important;
  margin-right: 4px;
  color: #666;
}
.fa-facebook {
  border: 1px solid rgb(60, 90, 154);
  color: rgb(60, 90, 154);
  padding: 7px 15px;
  border-radius: 0.25rem;
}

.fa-facebook:hover {
  background: rgb(60, 90, 154);
  color: #fff !important;
}

.fa-google {
  border: 1px solid rgb(220, 74, 61);
  color: rgb(220, 74, 61);
  padding: 7px 15px;
  border-radius: 0.25rem;
}

.fa-google:hover {
  background: rgb(220, 74, 61);
  color: #fff !important;
}

.otp {
  margin-right: 10px;
}

form input {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-align: center;
}

.login-bg {
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 1rem;
}
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scaleX(-1);
  z-index: -1;
  opacity: 0.4;
}
.bg-orange {
  background: linear-gradient(var(--primarycolor), var(--darkcolor));
}
.modal-title-otp a:hover {
  text-decoration: underline !important;
}

.primary-btn {
  background: var(--primarycolor);
  color: #fff;
  border-color: var(--primarycolor);
  padding: 0.5rem 8rem;
}

.is-valid-phone {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 9px;
  color: red;
}

.border {
  border: 1px solid #000;
}

.modal-title-otp {
  color: #579a70;
  cursor: pointer;
}

.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #fff;
  width: 65%;
}
#login-shopping-heading {
  font-weight: 400;
}
.signin-btn {
  width: 300px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  font-weight: 400;
  padding: 10px 5px;
  padding-left: 45px;
  font-size: 16px;
  border: 2px solid #aaa;
  margin-bottom: 12px;
}

.icon-img {
  height: 20px;
}

.google-btn img {
  background-color: white;
  border-radius: 50%;
}

.facebook-btn img {
  height: 18px;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px !important;
    padding: 0 10px;
  }
  .primary-btn {
    width: 100%;
    font-size: 16px;
    white-space: normal;
  }
  .card {
    margin: 20px auto;
    padding: 20px 15px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .v-input input {
    font-size: 16px;
  }

  .checkbox p {
    font-size: 13px;
  }

  .primary-btn {
    font-size: 16px;
    padding: 0.75rem;
  }

  .logo img {
    width: 60px;
  }
}
@media (max-width: 768px) {
  .login-left-side.pt-3 {
    padding-top: 0 !important;
  }

  .login-left-side h2 {
    font-size: 20px;
    margin-bottom: 0;
    text-align: center;
  }

  img.login-logo-icon.img-fluid {
    width: 30px;
  }

  #login-shopping-heading {
    margin-top: 0px !important;
    font-size: 20px;
    text-align: center;
    padding-bottom: 0 !important;
  }

  .btn-primary {
    padding: 0.5rem 1.5rem;
  }

  img.mt-2.teka-login-logo {
    margin-top: 0 !important;
  }
}
.logo img {
  width: 100%;
  max-width: 88;
  max-height: 91px;
  object-fit: cover;
}
.card {
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
</style>
